import React, { useRef } from "react";
import * as ReactDOMServer from "react-dom/server";
import { OrgChart } from "d3-org-chart";
import * as d3 from "d3";
import { useEffect, useState } from "react";
import { useGetOfficeHierarchyChart } from "../../../hooks/useGetOfficeHierarchyChart";
import {
  RecoilRoot,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { useHistory } from "react-router";
import { permissionsSelector } from "../../../../../Login/selectors/permissionSelector";
import { mainSelectedTab } from "../../../../atoms";
import { OfficeTabs } from "../../../../../OfficeTab/OfficeTabs";
import OHSPLCOrgChartNode from "./OHSPLCOrgChartNode";
import OHSPLCOrgChartButton from "./OHSPLCOrgChartButton";
import {
  dataId,
  empHierarchyState,
  officeFromOHChart,
  officeHierarchyModalState,
  officeHierarchyOnShowState,
  onClickNsaFullPage,
  onClickSalesFullPage,
  onClickSplcFullPage,
  setOfficeHierarchyRowForEdit,
} from "../../../atoms/atoms";
import { useQueryClient } from "react-query";
import useDeleteOfficeHierarchy from "../../../hooks/useDeleteOfficeHierarchy";
import { toast } from "../../../../../../components/toastNotification";
import ConfirmBoxDelete from "../../../../../../components/ConfirmBoxDelete";
import { PERMISSIONS } from "../../../../../PermissionsConstants";
import useSendEmail from "../../../hooks/useSendEmail";
import {
  ArrowDownCircleIcon,
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
  MinusCircleIcon,
  PlusCircleIcon,
} from "@heroicons/react/24/outline";
import jsPDF from "jspdf";
import PDFView from "modules/CarrierAgreementMgmt/OfficeHierarchy/pdfDownload/pdfView";
import axios from "axios";

const OHSPLCOrgCharts = () => {
  //Org Chart Data
  const { data: ohChart } = useGetOfficeHierarchyChart();
  const [dataChart, setDataChart] = useState();
  //For Deactivate
  const {
    mutate: deactivateHierarchyChart,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeleteOfficeHierarchy();
  //For send email
  const { mutateAsync: sendEmail } = useSendEmail();

  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [, setShowState] = useRecoilState(officeHierarchyOnShowState);
  const [, setOHIdData] = useRecoilState(dataId);
  const [, setIsParent] = useState(false);
  const [, setViewNsaData] = useRecoilState(onClickNsaFullPage);
  const [, setViewSalesData] = useRecoilState(onClickSalesFullPage);
  const [, setViewSplcData] = useRecoilState(onClickSplcFullPage);
  const [, setEditState] = useRecoilState(empHierarchyState);
  const [officeHierarchyId, setOfficeHierarchyId] = useState(0);
  const setRowToEdit = useSetRecoilState(setOfficeHierarchyRowForEdit);
  const [, setShowOfficeHierarchyModalState] = useRecoilState(
    officeHierarchyModalState
  );
  const [splcChartData, setSplcChartData] = useState();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [associatedActive, setAssociatedActive] = useState(false);
  const [, setShowFromOHChart] = useRecoilState(officeFromOHChart);
  const [compactChart, setCompactChart] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    setDataChart(ohChart?.data[0]?.officeHierarchySPLC);
  }, [ohChart?.data]);

  const d3Container = useRef(null);
  const chartRef = useRef(null);
  const containerStyles = {
    width: "100%",
    height: "100%",
  };

  const [cardShow, setCardShow] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [downloadAll, setDownloadAll] = useState(false);
  const [isShow, setShow] = useState(false);
  const api_base_url = process.env.REACT_APP_API_BASEURL;

  const [isClickedEllipsis, setIsClickedEllipsis] = useState(false);
  const handleShow = () => {
    setIsClickedEllipsis(true);
    setCardShow(true);
  };
  const handleClose = () => {
    setIsClickedEllipsis(false);
    setCardShow(false);
  };

  //Permission
  const deletePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_delete;
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_edit;

  //Redirection to employee for territory to district
  const toEmployee = (d) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        employeeId: d.data.employeeId,
        action: "SplcOrgChart",
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  //Redirection to employee for inside district
  const districtRegionToEmp = (d) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        employeeId: d.data.regionManagerId,
        action: "SplcOrgChart",
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  const districtAreaToEmp = (d) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        employeeId: d.data.areaManagerId,
        action: "SplcOrgChart",
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  const districtTerritoryToEmp = (d) => {
    const url = "/officesettings/officehierarchy";
    history.push({
      pathname: "/employeetab/employee",
      state: {
        employeeId: d.data.territoryManagerId,
        action: "SplcOrgChart",
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  const onClickOfficeHierarchyName = (rowData, isParent = false) => {
    setShowState(true);
    setOHIdData(rowData?.data.officeHierarchyId);
    setIsParent(isParent);
    setViewSplcData(true);
    setViewNsaData(false);
    setViewSalesData(false);
    history.push("/officesettings/officehierarchy/splc");
    localStorage.setItem("ohIdRedirect", rowData?.data?.officeHierarchyId);
    localStorage.setItem("path", "/officesettings/officehierarchy/splc");
  };

  //For area / region and territory code
  const onClickRegionCode = (rowData, isParent = false) => {
    setShowState(true);
    setOHIdData(rowData?.data.officeHierarchyRegionId);
    setIsParent(isParent);
    setViewSplcData(true);
    setViewNsaData(false);
    setViewSalesData(false);
    localStorage.setItem("ohIdRedirect", rowData?.data?.officeHierarchyId);
    history.push("/officesettings/officehierarchy/splc");
    localStorage.setItem("path", "/officesettings/officehierarchy/splc");
  };

  const onClickAreaCode = (rowData, isParent = false) => {
    setShowState(true);
    setOHIdData(rowData?.data.officeHierarchyAreaId);
    setIsParent(isParent);
    setViewSplcData(true);
    setViewNsaData(false);
    setViewSalesData(false);
    history.push("/officesettings/officehierarchy/splc");
    localStorage.setItem("ohIdRedirect", rowData?.data?.officeHierarchyId);
    localStorage.setItem("path", "/officesettings/officehierarchy/splc");
  };

  const onClickTerritoryCode = (rowData, isParent = false) => {
    setShowState(true);
    setOHIdData(rowData?.data.officeHierarchyTerritoryId);
    setIsParent(isParent);
    setViewSplcData(true);
    setViewNsaData(false);
    setViewSalesData(false);
    history.push("/officesettings/officehierarchy/splc");
    localStorage.setItem("ohIdRedirect", rowData?.data?.officeHierarchyId);
    localStorage.setItem("path", "/officesettings/officehierarchy/splc");
  };

  //For Edit
  const handleEdit = () => {
    setRowToEdit({
      ...splcChartData,
      idC: splcChartData.id_c ? splcChartData.id_c : "",
      name: splcChartData.name ? splcChartData.name : "",
      type: splcChartData.type ? splcChartData.type : null,
      owner: splcChartData.createdBy ? splcChartData.createdBy : "",
      parentHierarchyId: splcChartData.parentHierarchyId
        ? Number(splcChartData.parentHierarchyId)
        : "",
      managerEmployeeId: splcChartData.employeeId
        ? splcChartData.employeeId
        : null,
      managerEffectiveDate:
        splcChartData?.managerEffectiveDate !== null
          ? new Date(splcChartData.managerEffectiveDate)
              .toISOString()
              .split("T")[0]
          : splcChartData?.managerEffectiveDate,
      isActive: splcChartData?.isActive ? true : false,
      code: splcChartData.code ? splcChartData.code : "",
    });
    setShowOfficeHierarchyModalState(true);
  };

  //For Deactivate
  const deactivateHierarchy = () => {
    if (associatedActive === true) {
      setOpenModalDelete(false);
      setAssociatedActive(false);
    } else {
      deactivateHierarchyChart(officeHierarchyId);
      setOpenModalDelete(false);
    }
  };

  useEffect(() => {
    if (splcChartData) {
      //Filter territory hierarchy
      const validateAssociatedTerritory = dataChart?.filter(
        (x) =>
          splcChartData.territoryId !== 0 &&
          (x.territoryId === splcChartData.territoryId ||
            x.areaTerritoryId === splcChartData.territoryId ||
            x.officeHierarchyTerritoryId === splcChartData.id) &&
          x.id !== splcChartData.id
      );

      //Filter Area hierarchy
      const validateAssociatedArea = dataChart?.filter(
        (x) =>
          splcChartData.areaId !== 0 &&
          (x.areaId === splcChartData.areaId ||
            x.territoryId === splcChartData.areaTerritoryId ||
            x.officeHierarchyAreaId === splcChartData.id) &&
          x.id !== splcChartData.id
      );

      //Filter District hierarchy and associated offices
      const validateAssociatedDistrict = dataChart?.filter(
        (x) =>
          splcChartData.districtId !== 0 &&
          (x.officeHierarchyId === splcChartData.officeHierarchyAreaId ||
            x.officeHierarchyId === splcChartData.officeHierarchyTerritoryId ||
            Number(x.parentId) === splcChartData.id) &&
          x.id !== splcChartData.id
      );

      //Filter active hierarchies and open associated offices
      const validateActiveAssociatedOffice =
        validateAssociatedTerritory?.length > 0
          ? validateAssociatedTerritory.filter(
              (x) =>
                x.isActive === true ||
                (x.associatedOffices && x.associatedOffices?.length > 1) ||
                (x.associatedOffices &&
                  x.associatedOffices?.length === 1 &&
                  !x.associatedOffices[0]?.officeStatusName.includes("Closed"))
            )
          : validateAssociatedArea?.length > 0
          ? validateAssociatedArea.filter(
              (x) =>
                x.isActive === true ||
                (x.associatedOffices && x.associatedOffices?.length > 1) ||
                (x.associatedOffices &&
                  x.associatedOffices?.length === 1 &&
                  !x.associatedOffices[0]?.officeStatusName.includes("Closed"))
            )
          : validateAssociatedDistrict?.length > 0
          ? validateAssociatedDistrict.filter(
              (x) =>
                x.isActive === true ||
                (x.associatedOffices && x.associatedOffices?.length > 1) ||
                (x.associatedOffices &&
                  x.associatedOffices?.length === 1 &&
                  !x.associatedOffices[0]?.officeStatusName.includes("Closed"))
            )
          : [];

      if (validateActiveAssociatedOffice?.length > 0) {
        setAssociatedActive(true);
      } else {
        setAssociatedActive(false);
      }
    }
  }, [dataChart, splcChartData]);

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Office Hierarchy were deactivated successfully",
        "success"
      );
      deacResult.data.forEach((item) => {
        sendEmail(item);
      });
      queryClient.invalidateQueries("GetOfficeHierarchyChart");
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Office Hierarchy were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Deactivation of Office Hierarchy failed",
          "Server Error: Cannot deactivate Office Hierarchy",
          "error"
        );
      }

      queryClient.invalidateQueries("GetOfficeHierarchyChart");
    } else {
      toast.fire(
        "Deactivation of Office Hierarchy failed",
        "Server Error: Cannot deactivate Office Hierarchy",
        "error"
      );
      queryClient.invalidateQueries("GetOfficeHierarchyChart");
    }
    resetDeacData();
  }

  const deleteMessage = (
    <div className="text-gray-500 font-normal">
      {associatedActive === true
        ? "The releated hierarchies are still active. To deactivate, please modify the hierarchy to remove it's associations and assign new hierarchy."
        : "Are you sure you want to deactivate"}
    </div>
  );

  const onclickAssociatedOffice = (officeId) => {
    setShowFromOHChart(true);
    const url = "/officesettings/officesetting";
    history.push({
      pathname: url,
      state: {
        officeId: officeId,
        action: "AssociatedOffice",
        path: "/officesettings/officehierarchy/splc",
      },
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  useEffect(() => {
    if (dataChart && d3Container.current) {
      if (!chartRef.current) {
        chartRef.current = new OrgChart();
      }
      const chart = chartRef.current;

      chart
        .container(d3Container.current)
        .data(dataChart)
        // Chart line color
        .linkUpdate(function () {
          d3.select(this).attr("stroke", "#ced4da").attr("stroke-width", 2);
        })
        .nodeWidth((d) => {
          const hasSubtitle = d.data.parentId !== "";
          return hasSubtitle ? 300 : 300;
        })
        .nodeHeight((d) => {
          const hasSubtitle = d.data.parentId !== "";
          const baseHeight = hasSubtitle ? 120 : 120;

          // Set different heights for specific nodes
          if (d.data.districtType === "District") {
            return d.data.districtManager === null ? 167 : 204; // Height for District Manager
          } else if (d.data.type === "Office") {
            const height = d.data.associatedOffices.length * 10;
            return d.data.associatedOffices.length > 5
              ? 200 + height
              : baseHeight + height;
          } else {
            return baseHeight;
          }
        })

        .initialZoom(0.8)
        // .scaleExtent([0.8, 1.2]) // Set minimum and maximum scale extent
        .childrenMargin((d) => 120)
        .compactMarginBetween((d) => 100)
        .compactMarginPair((d) => 90)
        .siblingsMargin((d) => 80)
        .buttonContent(({ node }) => {
          return ReactDOMServer.renderToString(
            <OHSPLCOrgChartButton
              children={node.children}
              directSubordinates={node.data._directSubordinates}
            />
          );
        })
        .nodeContent((node) => {
          return ReactDOMServer.renderToString(
            <RecoilRoot>
              <OHSPLCOrgChartNode
                node={node}
                cardShow={cardShow}
                isClickedEllipsis={isClickedEllipsis}
                officeHierarchyId={officeHierarchyId}
                userPermissions={userPermissions}
                editPermission={editPermission}
                deletePermission={deletePermission}
                splcChartData={splcChartData}
              />
            </RecoilRoot>
          );
        })
        .nodeUpdate(function (d) {
          //Redirection for territory to area
          d3.select(this)
            .select(".node-card__name")
            .on("click", () => {
              toEmployee(d);
            });
          //Redirection for district
          d3.select(this)
            .select(".node-card__dis")
            .on("click", () => {
              toEmployee(d);
            });
          //Redirection for data inside district manager
          d3.select(this)
            .select(".node-card-dm.region")
            .on("click", () => {
              if (d.data.regionManager !== null) {
                districtRegionToEmp(d);
              }
            });
          d3.select(this)
            .select(".node-card-dm.area")
            .on("click", () => {
              districtAreaToEmp(d);
            });
          d3.select(this)
            .select(".node-card-dm.territory")
            .on("click", () => {
              districtTerritoryToEmp(d);
            });
          //For office hierarchy view full page
          d3.select(this)
            .select(".node-card__officeHierarchy")
            .on("click", () => {
              onClickOfficeHierarchyName(d, false);
            });
          d3.select(this)
            .select(".node-card__districtcode")
            .on("click", () => {
              onClickOfficeHierarchyName(d, false);
            });
          d3.select(this)
            .select(".node-card_regioncode")
            .on("click", () => {
              onClickRegionCode(d, false);
            });
          d3.select(this)
            .select(".node-card_areacode")
            .on("click", () => {
              onClickAreaCode(d, false);
            });
          d3.select(this)
            .select(".node-card_territorycode")
            .on("click", () => {
              onClickTerritoryCode(d, false);
            });
          // ellipsis
          d3.select(this)
            .select(".node-card__ellipsis")
            .on("click", () => {
              handleShow();
              setOfficeHierarchyId(d.data.officeHierarchyId);
              setSplcChartData(d.data);
            });
          //Edit button
          d3.select(this)
            .select(".edit")
            .on("click", () => {
              setEditState(true);
              setOfficeHierarchyId(officeHierarchyId);
              handleEdit();
              handleClose();
            });
          //Deactivate button
          d3.select(this)
            .select(".deactivate")
            .on("click", () => {
              setOpenModalDelete(true);
              setOfficeHierarchyId([officeHierarchyId]);
              handleClose();
            });
          //Close button
          d3.select(this)
            .select(".close")
            .on("click", () => {
              handleClose();
            });
          d3.select(this)
            .selectAll(".node-card_office h3")
            .on("click", function (event, d) {
              //Get office name
              const element = d3.select(this).text();
              //Filter the associated office data
              const filterData = dataChart
                .filter((x) => x.associatedOffices !== null)
                .map((y) => ({
                  ...y,
                  associatedOffices: y.associatedOffices.filter(
                    (z) => z.officeName.toLowerCase() === element.toLowerCase()
                  ),
                }))
                .filter((y) => y.associatedOffices.length > 0 && y.id === 0);

              //Get office id
              const associatedOffice = filterData.map(
                (x) => x.associatedOffices[0]
              );

              onclickAssociatedOffice(associatedOffice[0].officeId);
            });
          d3.select(this)
            .select(".node-rect")
            .attr("stroke", (d) => (d.data._highlighted ? "#152785" : "none"));
        })
        .compact(compactChart === true ? true : false)
        .layout("left")
        .render();
    }
  }, [
    dataChart,
    d3Container.current,
    cardShow,
    splcChartData,
    compactChart,
    isShow,
  ]);

  const style =
    "ml-2 text-VividBlue border-VividBlue opacity-100 flex items-center place-content-center whitespace-nowrap hover:scale-90 transition duration-500 bg-transparent border-VividBlue shadow-md hover:bg-VividBlue text-VividBlue group relative py-1 px-2 border text-xs font-medium rounded-full hover:text-white focus:outline-none hover:ring-2 focus:ring-offset-2 hover:ring-VividBlue focus:ring-opacity-70";
  const zoomIconStyle =
    "rounded-button h-4 w-4 text-VividBlue  gap-x-1 items-center bg-white opacity-100 hover:scale-90 hover:fill-VividBlue hover:text-white ease select-none focus:outline-none  place-content-center";
  const zoomButtomStyle =
    "ml-2 text-VividBlue border-VividBlue opacity-100 flex items-center place-content-center whitespace-nowrap transition duration-500 bg-transparent border-VividBlue text-VividBlue group relative px-3  text-md font-medium  focus:outline-none";

  const pdf = new jsPDF({ format: "a0" });
  const downloadPdf = (chart) => {
    if (downloadAll) {
      chartRef.current.collapseAll().render();
      setShow(true);
    } else {
      chart.exportImg({
        save: false,
        full: true,
        scale: 10,
        onLoad: async (base64) => {
          var img = new Image();
          img.src = base64;
          img.onload = async function () {
            let { width, height } = img;

            var pdf = new jsPDF({
              orientation: "portrait",
              format: [width, height],
            });

            // Set the display mode upon open of the pdf: Not applicable on web page pdf viewer
            pdf.setDisplayMode("45%", "single", "FullScreen");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            // Calculate scaling factors
            const scaleWidth = pdfWidth / width;
            const scaleHeight = pdfHeight / height;

            // Use the higher scaling factor to fit the image within the page
            const scale = Math.max(scaleWidth, scaleHeight);

            // Calculate new dimensions
            const newWidth = (width * scale) / 2;
            const newHeight = (height * scale) / 2;

            // Center the image on the page
            const x = (pdfWidth - newWidth) / 2;
            const y = (pdfHeight - newHeight) / 2;

            // Add the image to the PDF
            pdf.addImage(
              img,
              "PNG",
              x, // X-coordinate
              y, // Y-coordinate
              newWidth, // Scaled width
              newHeight, // Scaled height
              null,
              "FAST" // Use high-quality compression
            );

            // Convert to base64 string
            const pdfBase64 = pdf.output("datauristring").split(",")[1];

            // Send to API
            const response = await axios.post(
              `${api_base_url}/OfficeHierarchy/OrgChartDownload`,
              {
                contentType: "application/pdf",
                base64: pdfBase64,
                fileName: "SPLCHierarchyOrgChart.pdf",
              },
              { responseType: "arraybuffer" }
            );

            // Trigger download
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "SPLCHierarchyOrgChart.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            setIsDownloading(false);
          };

          img.onerror = (e) => console.error("Image load error:", e);
        },
      });
    }
  };

  return (
    <>
      <div className={`ml-7 border border-VividBlue ${downloadAll && "mr-2"}`}>
        <div className="text-md text-white flex items-center px-2 py-4">
          <button
            className={style}
            onClick={() => {
              chartRef.current?.expandAll().render().fit();
              setCompactChart(true);
              setDownloadAll(true);
            }}
          >
            <ArrowsPointingOutIcon className="h-4 w-4 mr-2" />
            Expand All
          </button>
          <button
            className={style}
            onClick={() => {
              chartRef.current?.collapseAll().render().fit();
              setCompactChart(false);
              setIsDisabled(false);
              setDownloadAll(false);
            }}
          >
            <ArrowsPointingInIcon className="h-4 w-4 mr-2" />
            Collapse All
          </button>
          <button
            className={
              isDisabled === true || isDownloading === true
                ? "ml-2 text-VividBlue border-VividBlue opacity-50 flex items-center place-content-center whitespace-nowrap hover:scale-90 transition duration-500 bg-transparent border-VividBlue shadow-md hover:bg-VividBlue text-VividBlue group relative py-1 px-2 border text-xs font-medium rounded-full hover:text-white focus:outline-none hover:ring-2 focus:ring-offset-2 hover:ring-VividBlue focus:ring-opacity-70"
                : "ml-2 text-VividBlue border-VividBlue opacity-100 flex items-center place-content-center whitespace-nowrap hover:scale-90 transition duration-500 bg-transparent border-VividBlue shadow-md hover:bg-VividBlue text-VividBlue group relative py-1 px-2 border text-xs font-medium rounded-full hover:text-white focus:outline-none hover:ring-2 focus:ring-offset-2 hover:ring-VividBlue focus:ring-opacity-70"
            }
            onClick={() => {
              downloadPdf(chartRef.current);
              setIsDownloading(true);
            }}
            disabled={isDisabled === true}
          >
            <ArrowDownCircleIcon className="h-4 w-4 mr-2" />
            {!isDownloading ? "Download" : "Downloading..."}
          </button>
          <div className="border-l ml-4 flex flex-row">
            <div>
              <button className={zoomButtomStyle}>
                <p>Zoom:</p>
                <div className="m-1">
                  <MinusCircleIcon
                    className={zoomIconStyle}
                    onClick={() => {
                      chartRef.current?.zoomOut();
                    }}
                  />
                </div>

                <div className="m-1">
                  <PlusCircleIcon
                    className={zoomIconStyle}
                    onClick={() => {
                      chartRef.current?.zoomIn();
                    }}
                  />
                </div>
              </button>
            </div>
          </div>
        </div>

        {isShow ? (
          <div>
            <PDFView
              downloading={setIsDownloading}
              show={setShow}
              Chart={ohChart?.data[0]?.officeHierarchySPLC}
              pdf={pdf}
              title={"SPLCHierarchyOrgChart.pdf"}
              compact={setCompactChart}
            />
          </div>
        ) : (
          <>
            <div
              className="closeEllipsis"
              style={containerStyles}
              ref={d3Container}
            />
          </>
        )}
      </div>
      {openModalDelete && (
        <ConfirmBoxDelete
          ModalTitle="Deactivate Office Hierachy"
          qConfirmation={deleteMessage}
          isOpen={openModalDelete}
          onClose={() => {
            setOpenModalDelete(false);
            setAssociatedActive(false);
          }}
          onClickFunction={deactivateHierarchy}
          cancelButtonRef={undefined}
        />
      )}
    </>
  );
};
export default OHSPLCOrgCharts;
